import React, { useState, useEffect } from 'react';
import { useApp } from '../../context/AppContext';
import Sidebar from '../../components/base/Sidebar/Sidebar';
import './disciplinas.css';

import AddLinkIcon from '@mui/icons-material/AddLink';
import LaunchIcon from '@mui/icons-material/Launch';
import CheckIcon from '@mui/icons-material/Check';
import WarningIcon from '@mui/icons-material/Warning';
import CloseIcon from '@mui/icons-material/Close';
import RunningWithErrorsOutlinedIcon from '@mui/icons-material/RunningWithErrorsOutlined';

import Card from '../../components/base/Card/Card';
import { useNavigate, useLocation } from 'react-router-dom';

function Disciplinas() {
  
  // alimenta primeira página com cards
  const [disciplinasAtivas, setDisciplinasAtivas] = useState([]);
  
  // alimenta popup de disciplina com as aulas daquela disciplina
  const [aulas, setAulas] = useState([]);


  const [selectedDisciplina, setSelectedDisciplina] = useState(null);
  const [selectedRelatorio, setSelectedRelatorio] = useState(null);
  

  const [message, setMessage] = useState(""); 
  const [isStudent, setIsStudent] = useState(false); 
  
  
  const { user } = useApp();
  const userID = user?.ID_usuario;
  const navigate = useNavigate();
  const location = useLocation();
  
  
  // não usados por enquanto
  const [attendanceMessage, setAttendanceMessage] = useState("");
  const [isLoadingAttendance, setIsLoadingAttendance] = useState(false);
  const [selectedAulaForAttendance, setSelectedAulaForAttendance] = useState(null); 
  const [attendanceData, setAttendanceData] = useState([]); // Lista de alunos para presença
  const [respostas, setRespostas] = useState({});
  const [attendanceStatus, setAttendanceStatus] = useState({}); // Status de presença por aluno
  const [isSubmitting, setIsSubmitting] = useState(false);




  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const email = params.get('email');
    
    if (email) {

      localStorage.setItem('userEmail', email);
      

      const newSearchParams = new URLSearchParams(location.search);
      newSearchParams.delete('email');
      const newUrl = window.location.pathname + (newSearchParams.toString() ? `?${newSearchParams.toString()}` : '');
      window.history.replaceState({}, '', newUrl);
      
      
      if (!userID) {
        localStorage.setItem('redirectAfterLogin', '/disciplinas');
        navigate('/login');
      }
    }



  }, [location, navigate]);

  useEffect(() => {
    localStorage.removeItem("tituloAula"); // Remove ao entrar na página de disciplinas para poder selecionar outra aula
  }, []);

  useEffect(() => {

    const fetchUserType = async () => {
      try {
        const response = await fetch(`https://rvensino.com.br/get.php?action=getCadastro&ID_usuario=${userID}`);
        const data = await response.json();

        if (data && Array.isArray(data) && data.length > 0) {
          const user = data[0];

          const isUserStudent = user.user_type !== "Professor";

          setIsStudent(isUserStudent);

        } else {
          console.warn("Formato inesperado da resposta da API para user type.", data);

          setIsStudent(true);
        }
      } catch (error) {
        console.error("Erro ao buscar tipo de usuário:", error);
        
        // visualização de estudante como default
        setIsStudent(true);
      }
    };


    // busca as disciplinas que o aluno está inscrito
    const fetchDisciplinasAtivas = async () => {
      try {

        const response = await fetch(`https://rvensino.com.br/get.php?action=get_disciplinas_by_aluno&ID_aluno=${userID}`);
        const data = await response.json();


        if (data && Array.isArray(data)) {

          setDisciplinasAtivas(data.map(d => ({
            class_id: d.class_id, 
            subscription_id: d.id,
            nome: d.disciplina, 
            turma: d.code,
            modalidade: d.modalidade,
            time: d.time, 
            year: d.year
          })));

        } else {
          
          
          console.warn("Formato inesperado da resposta da API.", data);
          setDisciplinasAtivas([]);


        }
      } catch (error) {

        console.error("Erro ao buscar disciplinas ativas:", error);
        setDisciplinasAtivas([]);

      }
    };

    if (userID) {
      fetchUserType();
      fetchDisciplinasAtivas();
    }
  }, [userID]);




  useEffect(() => {
    console.log('Aulas da disciplina', selectedDisciplina?.nome);
    console.log('Aulas: ', aulas);
  }, [aulas])






  const disciplinaIconMap = {
    'Biologia': 'bio',
    'Química': 'quimica',
    'Física': 'fisica',
    'Matemática': 'functions',
    'Redação': 'create',
    'Português': 'chat',
    'História': 'historia',
    'Geografia': 'geografia'
  };

  const handleRespostaChange = (num_questao, secao, campo, valor) => {
    setRespostas(prev => ({
      ...prev,
      [num_questao]: {
        ...prev[num_questao],
        secao,
        [campo]: valor
      }
    }));
  };


  const openPopup = async (disciplina) => {

    setSelectedDisciplina(disciplina);
    setSelectedRelatorio(null);

    try {

      //const response = await fetch(`https://rvensino.com.br/get.php?action=class_dates&class_id=${disciplina.class_id}`);
      const response = await fetch(`https://rvensino.com.br/get.php?action=get_aulas_by_turma_and_aluno&turma=${disciplina.class_id}&aluno=${userID}`); 
      console.log(`https://rvensino.com.br/get.php?action=get_aulas_by_turma_and_aluno&turma=${disciplina.class_id}&aluno=${userID}`)
      
      setMessage("");

      // Verifica se a resposta é bem-sucedida
      if (!response.ok) {
        throw new Error(`Erro na requisição: ${response.status} ${response.statusText}`);
      }

      // Verifica se o corpo da resposta não está vazio
      const responseText = await response.text();
      if (!responseText) {
        throw new Error('Resposta vazia recebida do servidor.');
      }

      // Tenta converter o texto da resposta para JSON
      let data;
      try {
        data = JSON.parse(responseText);

      } catch (jsonError) {
        throw new Error('Erro ao converter resposta para JSON: ' + jsonError.message);
      }

      setAulas(data);
    } catch (error) {
      console.error("Erro ao buscar aulas:", error);
      setAulas([]); 
    }
  };

  const closePopup = () => {
    localStorage.removeItem("tituloAula");
    setSelectedDisciplina(null);
    setSelectedRelatorio(null);
    // Also close attendance popup if open
    closeAttendancePopup();
  };

  const saveRelatorio = async (e) => {
    setTimeout(() => {
      navigate('/disciplinas');
    }, 2000);
  };

  const formatDate = (dateString) => {
    if (!dateString || dateString === "0000-00-00") return "-";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };

  
  const handleAttendanceClick = (aula) => {
    const classId = selectedDisciplina?.class_id;
    if (!classId || !aula.date) return;
    window.location.href = `https://rvensino.com.br/attendance.php?class_id=${classId}&date=${aula.date}`;
  };

  const closeAttendancePopup = () => {
    setSelectedAulaForAttendance(null);
    setAttendanceData([]);
    setAttendanceStatus({});
    setAttendanceMessage("");
  };

  return (
    <div className="page-container">
      <div className="menu">
        <Sidebar />
      </div>
      <div className='content disciplinas'>
        <div className={`content-container ${selectedDisciplina || selectedRelatorio || selectedAulaForAttendance ? 'blur' : ''}`}>
          <div className='subjects-container'>
            {disciplinasAtivas.map((disciplina, index) => {
              const icon = disciplinaIconMap[disciplina.nome] || 'default';
              
              return (
                <div key={index} onClick={() => openPopup(disciplina)}>
                  <Card
                    subject
                    title=''
                    info={disciplina.nome}
                    icon={icon}
                    unavailable={false}
                    time={disciplina?.time}
                    modality={disciplina?.modalidade}
                    turma={`Turma ${disciplina?.turma} (${disciplina?.year})`}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Popup de detalhes da disciplina */}
      {selectedDisciplina && !selectedRelatorio && (
        <div className="popup-overlay-subject" onClick={closePopup}>
          <div className="popup-content-subject" onClick={(e) => e.stopPropagation()}>
            <h2 className="subject-title">{selectedDisciplina.nome}</h2>

            <div className="subject-table">
              <table>
                <thead>
                  <tr>
                    <th>Número</th>
                    <th>Nome</th>
                    <th>Data da Aula</th>

                    {isStudent ? (
                      <th>Data de Entrega</th>
                    ) : (
                      <th>Lista de Presença</th>
                    )}
                    <th></th>
                    {/* coluna de status só aparece para alunos */}
                    {isStudent && <th>Status</th>}
                  </tr>
                </thead>

                <tbody>
                  {aulas.length > 0 ? (
                    aulas.map((aula, i) => (
                      <tr key={i}>
                        <td>{aula.numero}</td>
                        <td>{aula.nome}</td>
                        <td>{formatDate(aula.date)}</td>
                        
                        {/* data de entrega do relatório só aparece para alunos */}
                        {isStudent ? (
                          <td>{aula.report_date === '0000-00-00' || aula.has_questions === 0 ? '-' : formatDate(aula.report_date)}</td>
                        ) : (
                          <td>
                            {aula.numero === 'F' || aula.numero === 'RD' ? null : aula.attendance_filled
                              ? <CheckIcon style={{ color: 'green', fontSize: 24 }} />
                              : <span style={{ color: '#999' }}>Não Preenchida</span>}
                          </td>
                        )}

                        <td>
                          {isStudent ? (
                            aula.report_date !== '0000-00-00' && aula.delivered !== 1 && aula.has_questions !== 0 ? (
                              <AddLinkIcon
                                style={{ color: '#000', fontSize: 30, cursor: 'pointer' }}
                                onClick={async () => {
                                  try {
                                    const responseUser = await fetch(`https://rvensino.com.br/get.php?action=criptografar&data=${userID}`);
                                    const encryptedUserID = await responseUser.text();

                                    const responseAula = await fetch(`https://rvensino.com.br/get.php?action=criptografar&data=${aula.id}`);
                                    const encryptedAulaID = await responseAula.text();

                                    window.location.href = `https://rvensino.com.br/relatorio.php?uid=${encodeURIComponent(encryptedUserID)}&aid=${encodeURIComponent(encryptedAulaID)}`;
                                  } catch (error) {
                                    console.error('Erro ao criptografar dados:', error);
                                  }
                                }}
                              />
                            ) : null
                          ) : (
                            aula.numero !== 'F' && aula.numero !== 'RD' ? (
                              <LaunchIcon
                                style={{
                                  color: '#2196F3',
                                  fontSize: 30,
                                  cursor: 'pointer'
                                }}
                                onClick={() => handleAttendanceClick(aula)}
                              />
                            ) : null
                          )}
                        </td>

                        {/* coluna de status só aparece para alunos */}
                        {isStudent && (
                          <td>
                            {aula.has_questions === 0 ? null : aula.delivered === 1 ? (
                              <CheckIcon style={{ color: 'green', fontSize: 24 }} />
                            ) : aula.report_late ? (
                              <CloseIcon style={{ color: 'red', fontSize: 24 }} />
                            ) : aula.nearly_report_date ? (
                              <RunningWithErrorsOutlinedIcon style={{ color: 'orange', fontSize: 24 }} />
                            ) : null}
                          </td>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={isStudent ? "6" : "5"}>Nenhuma aula encontrada</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <button className="close-popup-subject" onClick={closePopup}>X</button>
          </div>
        </div>


      )}



    </div>
  );
}

export default Disciplinas;